import { render, staticRenderFns } from "./ycd-payment-index.vue?vue&type=template&id=59478778&scoped=true&"
import script from "./ycd-payment-index.vue?vue&type=script&lang=ts&"
export * from "./ycd-payment-index.vue?vue&type=script&lang=ts&"
import style0 from "./ycd-payment-index.vue?vue&type=style&index=0&id=59478778&lang=less&scoped=true&"
import style1 from "./ycd-payment-index.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59478778",
  null
  
)

export default component.exports